import { useMutation } from '@tanstack/react-query'
import Api from 'services/Api'
import { UPLOAD_ATTACHMENTS_TYPES } from 'common'
import { triggerResourcesRefresh } from 'store/actions/resources'
import { setUserInfo } from 'store/actions/users'
import { useDispatch } from 'react-redux'
import { Dispatch } from 'redux'

type DeleteParams = {
  key: string
  userId: string
}

const reloadUserInfo = (dispatch: Dispatch) => {
  triggerResourcesRefresh(dispatch, { resource: ['users'] })
  dispatch(setUserInfo())
}

const useDeleteProfilePicture = () => {
  const dispatch = useDispatch()
  return useMutation({
    mutationFn: async (params: DeleteParams) =>
      await Api.delete(`users/picture`, {
        params: {
          ...params,
          attachmentType: UPLOAD_ATTACHMENTS_TYPES.PROFILE
        }
      }),
    onSuccess: () => {
      reloadUserInfo(dispatch)
    }
  })
}

export { useDeleteProfilePicture }
